// PrimeVue DatePicker locale configurations
export const primevueLocales: Record<string, any> = {
  en: {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    today: 'Today',
    clear: 'Clear'
  },
  es: {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
    monthNames: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ],
    monthNamesShort: [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic'
    ],
    today: 'Hoy',
    clear: 'Limpiar'
  },
  fr: {
    firstDayOfWeek: 1,
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    monthNames: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre'
    ],
    monthNamesShort: [
      'Jan',
      'Fév',
      'Mar',
      'Avr',
      'Mai',
      'Jun',
      'Jul',
      'Aoû',
      'Sep',
      'Oct',
      'Nov',
      'Déc'
    ],
    today: "Aujourd'hui",
    clear: 'Effacer'
  },
  msa: {
    firstDayOfWeek: 0,
    dayNames: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesShort: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
    dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
    monthNames: [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر'
    ],
    monthNamesShort: [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر'
    ],
    today: 'اليوم',
    clear: 'مسح'
  },
  so: {
    firstDayOfWeek: 0,
    dayNames: ['Axad', 'Isniin', 'Talaado', 'Arbaco', 'Khamiis', 'Jimco', 'Sabti'],
    dayNamesShort: ['Axd', 'Isn', 'Tal', 'Arb', 'Kha', 'Jim', 'Sab'],
    dayNamesMin: ['Ax', 'Is', 'Ta', 'Ar', 'Kh', 'Ji', 'Sa'],
    monthNames: [
      'Janaayo',
      'Febraayo',
      'Maarso',
      'Abriil',
      'May',
      'Juun',
      'Luuliyo',
      'Ogost',
      'Sebtembar',
      'Oktoobar',
      'Nofembar',
      'Desembar'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Luu',
      'Ogo',
      'Seb',
      'Okt',
      'Nof',
      'Des'
    ],
    today: 'Maanta',
    clear: 'Bixi'
  },
  hmn: {
    firstDayOfWeek: 0,
    dayNames: ['Zwj hnub', 'Zwj hli', 'Zwj quag', 'Zwj feeb', 'Zwj teeb', 'Zwj kuab', 'Zwj cag'],
    dayNamesShort: ['Hnub', 'Hli', 'Quag', 'Feeb', 'Teeb', 'Kuab', 'Cag'],
    dayNamesMin: ['Zn', 'Hl', 'Qu', 'Fe', 'Te', 'Ku', 'Ca'],
    monthNames: [
      'Ib Hli',
      'Ob Hli',
      'Peb Hli',
      'Plaub Hli',
      'Tsib Hli',
      'Rau Hli',
      'Xya Hli',
      'Yim Hli',
      'Cuaj Hli',
      'Kaum Hli',
      'Kaum Ib Hli',
      'Kaum Ob Hli'
    ],
    monthNamesShort: [
      'Ib Hli',
      'Ob Hli',
      'Peb Hli',
      'Plaub Hli',
      'Tsib Hli',
      'Rau Hli',
      'Xya Hli',
      'Yim Hli',
      'Cuaj Hli',
      'Kaum Hli',
      'Kaum Ib',
      'Kaum Ob'
    ],
    today: 'Hnub no',
    clear: 'Tso tawm'
  }
}
